export const getLiveAccountResponse = (response) => {
  const totalData = response?.totalData ?? 0;
  const totalPage = response?.totalPage ?? 0;
  const isDataExist = response?.isDataExist;

  const liveAccounts = response?.accountLivestreams?.map((item) => {
    return {
      id: item?.id,
      brand: item?.brands?.map((item) => item?.name),
      platform: item?.ecommerce?.name,
      accountType: item?.accountType?.name,
      parentAccount: item?.parentAccount?.name,
      name: item?.name,
      storeName: item?.storeName,
      rawData: item,
    };
  });

  return { liveAccounts, totalData, totalPage, isDataExist };
};

export default getLiveAccountResponse;
